/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { selectFieldSchema } from "data/store/reducers/schema-model";

/**
 * Gets a field schema from the current model
 * @param {string} fieldName 
 */
export function useSelectFieldSchema (fieldName) {
    const schema = useSelector(
        (state) => selectFieldSchema(state, fieldName)
    );

    return schema;
}
